import LoaderWrapper from './loaderWrapper'
export default LoaderWrapper
